<template class="my-checkbox" style="height:100%;">
    <section style="height:100%;">

        <div class="w100 h100 column flex-centerall" style="background:url('https://img.js.design/assets/img/623d701f533416ca46a5a97f.png') 100% 100% no-repeat;background-position:center; ">
                <div class="w100 font40">衡七管家智慧称重预约后台管理系统</div>
                <div class="grey9_text font24 mb40" v-if="company_name">{{company_name}}@服务商</div>
                <div class="row flex-center">
                    <div class="white_bg br10 column flex-centerall" style="width:1057px;height:481px;">
                        <div class="row flex-center">
                            <img src="../../static/img/login01.png" class="mr20" style="widht:418px;height:418px;"/>
                            <div>
                                <div class="font24 mb5">用户登录</div>
                                <div class="red_text font15 mb5" v-if="loginStatus=='err'">温馨提示：用户名或者密码错误</div>
                                <div class="row flex-start" style="width:357px;height:43px;border:solid 1px #eee">
                                    <img src="../../static/img/user01_hq.png" class="ml15 mr15" style="width:20px;height:20px;"/>
                                    <input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="请输入用户名" style="border:0;height:100%;"/>
                                </div>
                                <div class="row flex-start mt25 mb25" style="width:357px;height:43px;border:solid 1px #eee">
                                    <img src="../../static/img/key01_hq.png" class="ml15 mr15" style="width:20px;height:20px;"/>
                                    <input type="text" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="请输入密码" style="border:0;height:100%;"/>
                                </div>
<!--                                <div class="yellow_bg row flex-center mt25" style="height:43px;">登录</div>-->

                                <el-button class="set-other-btn " style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">
                                    登录
                                </el-button>
                                <div class="row flex-center mt15 font10"><img src="../../static/img/yes01.svg" class="mr5" style="width:18px;height:18px;">授权即视为已同意<div class="fontwb cursorp" @click="toxieyi('user')">《用户协议》</div>与<div class="fontwb cursorp" @click="toxieyi('privacy')">《隐私协议》</div></div>
                                <div class="row flex-between mt25">
                                <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>

        <div class="position_f w100 tc font16" style="left:0;bottom:30px;">{{company_name}}@版权所有 2022V3.0</div>
<!--        <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px"-->
<!--                 class="demo-ruleForm login-container">-->
<!--            <h3 class="title">系统登录</h3>-->
<!--            <el-form-item prop="account">-->
<!--                <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="账号"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item prop="checkPass">-->
<!--                <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="密码"></el-input>-->
<!--            </el-form-item>-->
<!--            <a style="float:right;color: dodgerblue" @click="forgetPwd();">忘记密码?</a>-->
<!--            <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>-->
<!--            <el-form-item style="width:100%;">-->
<!--                <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">-->
<!--                    登录-->
<!--                </el-button>-->
<!--                &lt;!&ndash;<el-button @click.native.prevent="handleReset2">重置</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
<!--        </el-form>-->

        <!--找回密码界面1-->
        <el-dialog title="找回密码" v-model="pwdForm1" width="25%" :close-on-click-modal="false" :visible.sync="pwdFormVisible1">
            <el-form :model="pwdForm1" label-width="80px" :rules="pwdFormRules1" ref="pwdForm1" style="margin-right: 20px;">
                <span style="margin-left: 80px;color: #ff6d6d">*请填写您需要找回密码的帐号</span>
                <el-form-item label="账号" prop="account">
                    <el-input v-model="pwdForm1.account" placeholder="请填写您需要找回密码的帐号" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="pwdFormVisible1 = false">取消</el-button>
                <el-button type="primary" @click.native="pwdSubmit1">下一步</el-button>
            </div>
        </el-dialog>

        <!--找回密码界面2-->
        <el-dialog title="找回密码" v-model="pwdForm2" width="50%"   :close-on-click-modal="false" :visible.sync="pwdFormVisible2">
            <el-form :model="pwdForm2" label-width="100px" :rules="pwdFormRules2" ref="pwdForm2" style="margin-right: 20px;">

                <el-form-item label="手机号码" prop="phoneNum" >
                    <el-input v-model="pwdForm2.phoneNum" auto-complete="off" ></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="valCode">
                    <el-input type="number" v-model="pwdForm2.valCode"></el-input>
                    <el-button type="primary" size="mini" v-bind:disabled="sendCodeBtn" @click.native="handleGetCode()">{{sendCodeBtn_text}}</el-button>
                </el-form-item>
                <el-form-item label="密码" prop="pwd" >
                    <el-input type="password" v-model="pwdForm2.pwd" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="pwd2" >
                    <el-input type="password" v-model="pwdForm2.pwd2" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="logining" @click="handleNext()">提交</el-button>
                    <el-button @click="pwdFormVisible2=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </section>
</template>

<script>
    import md5 from 'js-md5';
    import axios from 'axios';
    import  {mobileValidate} from '../api/baseApi.js'
    import { login} from "../api/partner/login";
    import {dataURLtoBlob,dataURLtoFile} from '../utils/date.js'
    export default {

        data() {
            return {
                        windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            loginStatus:'',
            company_name:'',
                logining: false,
                ruleForm2: {
                    account: '',
                    checkPass: ''
                },
                rules2: {
                    account: [
                        {required: true, message: '请输入账号', trigger: 'blur'},
                        //{ validator: validaePass }
                    ],
                    checkPass: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        //{ validator: validaePass2 }
                    ]
                },
                checked: true,
                logining: false,
                pwdFormVisible1: false,
                pwdFormVisible2: false,
                sendCodeBtn: false,
                pwdForm1: {
                    account: ""
                },
                pwdForm2: {
                    account: "",
                    phoneNum: "",
                    valCode: "",
                    pwd: "",
                    pwd2: ""
                },
                pwdFormRules1: {
                    account: [
                        {required: true, message: '请填写您需要找回密码的帐号.', trigger: 'blur'}
                    ]
                },
                pwdFormRules2: {
                    account: [
                        {required: true, message: '请填写您需要找回密码的帐号.', trigger: 'blur'}
                    ],
                    phoneNum: [
                        {required: true, message: '请填写您的手机号码.', trigger: 'blur'}
                    ],
                    valCode: [
                        {required: true, min: 4, max: 6, message: '请填写您收到的4位验证码.', trigger: 'blur'}
                    ],
                    pwd: [
                        {required: true, message: '请填写密码.', trigger: 'blur'},
                        {min: 6, max: 16, message: '密码长度必须为6至16位.', trigger: 'blur'}
                    ],
                    pwd2: [
                        {required: true, message: '请再次填写密码.', trigger: 'blur'},
                        {min: 6, max: 16, message: '密码长度必须为6至16位.', trigger: 'blur'}
                    ]
                },
                countdown: 60, // 发送验证码倒计时
                sendCodeBtn_text: "发送验证码"
            };
        },
        methods: {
        toxieyi(val){
          this.$router.push({path: '/xieyi',query:{type:val}})
        },
            handleReset2() {
                this.$refs.ruleForm2.resetFields();
            },
            handleSubmit2(ev) {
                let self=this;
               // this.$refs.ruleForm2.validate((valid) => {
                   // if (valid) {
                        //_this.$router.replace('/table');
                        self.logining = true;
                        //NProgress.start();
                        //const pwd=md5(this.ruleForm2.checkPass);
                        var loginParams =
                        {

                            "password": this.ruleForm2.checkPass,
                            "group_id": 4,
                            "account": this.ruleForm2.account
                        }
                        let url=this.baseApiUrl+'user/login';
                   axios.post(url,loginParams).then( data => {


                        self.loginStatus=''
                    if(data.data.code==1){
                        let user = data.data.data.userinfo;
                         window.localStorage.setItem('user',JSON.stringify(user));

            self.$axios.get(self.baseApiUrl+'user/index').then(function (res) {
                user.company_name=res.data.data.user.company_name
             window.localStorage.setItem('user',JSON.stringify(user));
              //记住密码
          if (self.checked) {
            window.localStorage.setItem("username", self.ruleForm2.account);
            window.localStorage.setItem("password", self.ruleForm2.checkPass);
          } else {
            window.localStorage.removeItem("username");
            window.localStorage.removeItem("password");
          }

             self.$router.push({path: '/mainIndex'});
            })

                               }
                       else{
                        console.log("cuo1121")
                        self.loginStatus='err'
                            this.logining = false;
                               }
                        }).catch((error)=>{

                        console.log("错1121")
                            this.logining = false;

                        });

                  //  } else {
                     //   console.log('error submit!!');
                    //    return false;
                   // }
               // });
            },
        loadMemberDetail(userid,token,userRole){//用户信息
            let self = this;
            let url = self.baseApiUrl + "/users/current";
            axios.get(url).then(resp => {
                self.logining = false;
                let user = resp.data.data;

                user.token=token;
                user.roles=userRole;
                self.$store.dispatch('SetRole',[]).then(() => { // 根据roles权限生成可访问的路由表

                })


                window.localStorage.setItem('user',JSON.stringify(user));
                self.$router.push({path: '/main'});
            }).catch(error => {
                this.$message({
                    message: error.message,
                    type: 'warning'
                });
            });
        },

        forgetPwd() {
              //  this.pwdForm1.account=this.ruleForm2.account;
              //  this.pwdFormVisible1=true;
                this.pwdFormVisible2=true;
            },
            pwdSubmit1() {
                this.$refs.pwdForm1.validate((valid) => {
                    if (valid) {
                        let params = {
                            userNm: this.pwdForm1.account
                        };
                        let that=this;
                        axios.get(this.baseApiUrl+this.AGXPARTNER+'/v1'+'/sysUser/findSysUserByUserNm', {params: params}).then(function (res) {
                            that.pwdFormVisible1=false;
                            that.pwdFormVisible2=true;
                            that.pwdForm2.account=that.pwdForm1.account;
                            that.pwdForm2.phoneNum=res.data.phoneNum;
                        }).catch(function (error) {
                            if (error.response) {
                                that.$message({
                                    type: 'warning',
                                    message: error.message
                                });
                            }
                        });
                    }
                })
            },
                //重置密码
            handleGetCode() {

                let self = this;
                if (self.pwdForm2.phoneNum.length<=0) {
                    self.$vux.toast.text("请输入手机号码");
                    return
                }
                if (!mobileValidate(self.pwdForm2.phoneNum)) {
                    self.$vux.toast.text("手机号码格式不正确");
                    return
                }
                var key = '31e7c656-4cf6-4f5f-abfb-eec00468270d';
                var authKey = md5(key + self.pwdForm2.phoneNum);
                var paramas = {
                    appid: '14214c7a17474af58191aa2a1ceb5ef2',
                    phone: self.pwdForm2.phoneNum,
                    smsType: 'RET_PWD',
                    authKey: authKey.toUpperCase()
                }
                self.$axios.post(this.baseApiUrl+this.AGXPARTNER+'/v1' + "/sms/send", paramas).then((res) => {
                    this.sendCodeBtn = true;
                    this.sendCodeBtn_text = '获取中...';
                    let seconds = 120;
                    let time = setInterval(function () {
                        --seconds;
                        self.sendCodeBtn_text = seconds + 's';
                        if (seconds <= 0) {
                            clearInterval(time);
                            self.sendCodeBtn = false;
                            self.sendCodeBtn_text = '获取验证码';
                        }
                    }, 1000)
                }).catch(error => {
                    self.$message({
                        type: 'warning',
                        message: error.message
                    });
                })

            },
            handleNext() {
                this.$refs.pwdForm2.validate((valid) => {
                    if (valid) {
                        let self = this;
                        if ( !self.pwdForm2.pwd2) {
                            self.$message({
                                type: 'warning',
                                message: '请再次输入密码'
                            });
                            return;
                        }
                        if (self.pwdForm2.pwd != self.pwdForm2.pwd2) {
                            self.$message({
                                type: 'warning',
                                message: '两次输入的密码不一致'
                            });
                            return;
                        }

                        let params = {
                            appid: '14214c7a17474af58191aa2a1ceb5ef2',
                            phoneNum: self.pwdForm2.phoneNum,
                            code: self.pwdForm2.valCode,
                            confirmPassword: self.pwdForm2.pwd2,
                            password: self.pwdForm2.pwd
                        };
                        self.logining=true;
                        self.$axios.post(this.baseApiUrl+this.AGXPARTNER+'/v1' + '/sso/reset-pwd', params).then(function (res) {
                            self.logining=false;
                            self.$message({
                                type: 'warning',
                                message: '密码重置成功'
                            });
                            self.pwdFormVisible2=false;

                        }).catch(function (error) {
                            self.logining=false;
                            self.$message({
                                type: 'warning',
                                message: error.message
                            });
                        });

                    }
                });


        }

        },

        mounted: function () {

console.log("window.localStorage.getItemusername")
console.log(window.localStorage.getItem("username"))
        this.ruleForm2.account = window.localStorage.getItem("username");
        this.ruleForm2.checkPass = window.localStorage.getItem("password");company_name

        let company_name = window.localStorage.getItem("company_name");
        if(company_name){
        this.company_name=company_name
        }
          if (typeof this.ruleForm2.account == "string") {
              this.checked = true;
            } else {
              this.checked = false;
            }

        },
    }

</script>

<style lang="scss">
  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate
  .el-checkbox__inner{
      background-color:#fdf006;
      border-color:#fdf006;
     }
  .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #000;
     }
  .el-checkbox.is-bordered.is-checked{
      border-color: #fdf006;
     }
  .el-checkbox__input.is-focus .el-checkbox__inner{
      border-color:  #fdf006;
     }




     .set-other-btn{
  color: #000;height:43px;
  background-color: #fef03e;
  border-color: #fef03e;
}
.set-other-btn:hover {//鼠标悬浮
background-color: #fff35e; border-color: #fff35e;
  color: #000; }

.set-other-btn:focus {//鼠标点击
  background-color:  #fdf006;
  border-color:  #fdf006;color: #000;
}


.set-other-btn.is-disabled{
  background-color: #FE83C6;
  border-color: #FE83C6;color: #000;
}
.set-other-btn.is-disabled:hover{
  background-color:  #FE83C6;
  border-color:  #FE83C6;color: #000;
}


</style>



// WEBPACK FOOTER //
// Login.vue?6bd8fafb